import { createAction } from 'typesafe-actions';
import { IPumpingStationVoluteCasingMake } from '../../../../@types/model/masterData/pumpingStation/voluteCasingMake';

export default class MasterDataPumpingStationVoluteCasingMakeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_MAKES', resolve => (pumps : Array<IPumpingStationVoluteCasingMake>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_MAKES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}